import uuid from 'uuid';
import { Text } from 'slate';
import BlockTypes from '../../../types/BlockTypes';
export default function insertTable(editor) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$tableId = _ref.tableId,
      tableId = _ref$tableId === void 0 ? uuid() : _ref$tableId,
      _ref$rows = _ref.rows,
      rows = _ref$rows === void 0 ? 2 : _ref$rows,
      _ref$columns = _ref.columns,
      columns = _ref$columns === void 0 ? 2 : _ref$columns;

  var type = BlockTypes.TABLE_CELL;
  return editor.withoutNormalizing(function () {
    for (var i = 1; i <= rows; i++) {
      for (var j = 1; j <= columns; j++) {
        editor.insertBlock({
          type: type,
          data: {
            tableId: tableId,
            rowBreak: j === columns || undefined
          },
          nodes: [Text.create()]
        });
      }
    }

    for (var _i = 0; _i < rows * columns - 1; _i++) {
      editor.moveToStartOfPreviousBlock();
    }
  });
}